import {get as _get, find as _find, random as _random} from 'lodash';


import initialState from '../initialstate';

import {
	GET_GS_SCOPE_SEND_VERSION,
	CHANGE_GS_SV_TEAM,
	CHANGE_GS_SV_SCOPE,
	POST_GS_SCOPE_SEND_VERSION,
	ADD_ERROR_SV_TEAM
} from '../../actions/actiontypes';
import {GALinkStatus} from '../../util/uiconstants';
import {currentResource, labels} from '../../util/utils';
import normalizeScopesSendVersion from './normalizeScopesSendVersion';
import updateTeamsSendVersion from './updateTeamsSendVersion';
import updateScopesSendVersion from './updateScopesSendVersion';
import updateErrorAndDatesTeamsSendVersion from './updateErrorAndDatesTeamsSendVersion';

export default function getGSScopesSVTeamsData(state = initialState.gsScopesSendVersion, action) {
	switch (action.type) {
		case GET_GS_SCOPE_SEND_VERSION: {
			const status = _get(action, 'responseObj.status', null);
			if (status) {
				let data = _get(action, 'response', []).filter(
					(team) => team.gaLinkStatusId !== GALinkStatus.ComponentReferenceOnly
				);
				const scopes = [];
				_.forEach(_.groupBy(data, 'gaScopeName'), (value, key) => {
					scopes.push({
						gaScopeId: value[0]['gaScopeId'],
						type: value[0]['gaScopeTypeId'],
						gaScopeName: value[0]['gaScopeName'],
						isSubScope: value[0]['isSubScope'],
						scopeInstructionSentDate: value[0]['scopePublishDate'],
						teamList: value
					});
				});
				return normalizeScopesSendVersion(scopes);
			}
			return state;
		}
		case POST_GS_SCOPE_SEND_VERSION: {
			const sucessLabel = _get(action, 'sucessLabel', null);
			const teamId = _get(action, 'teamId', null);
			const isNewer = _get(action, 'isNewer', null);

			const error = action.error?.response?.data?.errors?.Error[0].split(' - ');
			let errorFormated;
			if (error) {
				errorFormated = `<b>${error[0]}:</b> ${currentResource.Errors[error[0]]}`;
				return updateErrorAndDatesTeamsSendVersion({scopes: state, teamId, error: errorFormated});
			}
			if (!error && !isNewer) {
				return updateErrorAndDatesTeamsSendVersion({
					scopes: state,
					teamId,
					error: false,
					success: true,
					label: labels.newersTeamsSended,
					isNewer
				});
			}
			if (!error && isNewer) {
				return updateErrorAndDatesTeamsSendVersion({
					scopes: state,
					teamId,
					error: true,
					label: labels.latestHasBeenSended,
					isNewer
				});
			}
			return state;
		}

		case CHANGE_GS_SV_TEAM: {
			const teamId = _get(action, 'teamId', null);

			if (teamId) {
				return updateTeamsSendVersion(state, teamId);
			}

			return state;
		}

		case CHANGE_GS_SV_SCOPE: {
			const scopeId = _get(action, 'scopeId', null);
			const checked = _get(action, 'checked', null);

			if (scopeId) {
				const afterChange = updateScopesSendVersion(state, scopeId, checked);
				return afterChange;
			}

			return state;
		}
		default:
			return state;
	}
}
